var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{model:{value:(_vm.trigger),callback:function ($$v) {_vm.trigger=$$v},expression:"trigger"}},[_c('transition',{attrs:{"name":"fade"}},[[_vm._t("default")]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }